import {is_function, isMSIE} from '../../../Helpers/js/simple.functions';
import LP from '../0-lp';

//----------------- //
//jQPlot UI        //
//----------------- //
LP.UI.jQPlot = {

    path: '',
    pluginPath: '',
    plots: new Array(),

    loadCharts: function () {
        for (var i = 0; i < LP.UI.jQPlot.plots.length; i++) {
            if (is_function(LP.UI.jQPlot.plots[i])) {
                LP.UI.jQPlot.plots[i]();
            }
        }
        LP.UI.jQPlot.plots = new Array();
    },

    load: function (jqPath, excanvasJS, onLoad) {
        LP.UI.jQPlot.path = jqPath;
        LP.UI.jQPlot.pluginPath = jqPath + 'plugins/';

        if (isMSIE()) window.Browser.addJavascript(excanvasJS);
        window.Browser.addJavascript(LP.UI.jQPlot.path + 'jquery.updated-jqplot.min.js', 'jqplot', true);

        LP.UI.jQPlot.plots.push(onLoad);
    },

    add: function (plugin) {
        window.Browser.addJavascript(LP.UI.jQPlot.pluginPath + plugin, 'jqplug_' + plugin, true);
    }
};


